import IssueReportsCommands from './issueReportsCommands';

const Command = {
    IssueReport: IssueReportsCommands,
};

export default Command;
